const tint = (id) => (id % 4) + 1

// A single journal entry — the cover taped in like a photo, with a
// handwritten caption below. Clicking opens the modal (React state).
const BookCard = ({ book, onOpen }) => {
  const open = (event) => {
    event.preventDefault()
    onOpen()
  }

  return (
    <article className="entry">
      <a className="entry__photo-link" href={`/books/${book.id}`} onClick={open} aria-label={book.title}>
        {book.cover_url ? (
          <div className="entry__photo">
            <img src={book.cover_url} alt={book.title} loading="lazy" decoding="async" />
          </div>
        ) : (
          <div className={`entry__photo entry__photo--blank t${tint(book.id)}`}>
            <span className="entry__blank-title">{book.title}</span>
            <span className="entry__blank-author">{book.author}</span>
          </div>
        )}
      </a>

      <div className="entry__caption">
        <a className="entry__title" href={`/books/${book.id}`} onClick={open}>
          {book.title}
        </a>
        <span className="entry__author">— {book.author}</span>
        <div className="entry__meta">
          {book.genre && <span className="entry__genre">#{book.genre}</span>}
          {book.added_on && <span className="entry__date">{book.added_on}</span>}
        </div>
      </div>
    </article>
  )
}

export default BookCard
